/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import cx from 'classnames';
import {} from 'sarsaparilla';

import { MAX_SEARCH_RESULTS } from '../actions/search';

import styles from './NoSearchResultsMessage.module.scss';

interface NoSearchResultsMessageProps {
    hasHiddenResults: boolean;
    hiddenResultsCount: number;
    onResetMapClick: () => void;
    isResetMapDisabled: boolean;
}

export function NoSearchResultsMessage({
    hasHiddenResults,
    hiddenResultsCount,
    onResetMapClick,
    isResetMapDisabled,
}: NoSearchResultsMessageProps) {
    if (hasHiddenResults && hiddenResultsCount > 0) {
        const formattedResultCount =
            hiddenResultsCount >= MAX_SEARCH_RESULTS
                ? `${MAX_SEARCH_RESULTS}+`
                : hiddenResultsCount < 10
                  ? ''
                  : hiddenResultsCount;

        return (
            <div className={cx(styles.noResultsMessage, 'mt-3 mb-5')}>
                <div className="heading-sm mb-1">
                    All {formattedResultCount} results are off the map
                </div>
                <p className="text-lg color-text-02 mb-4">
                    Zoom out or{' '}
                    <button
                        type="button"
                        className={cx(styles.resetMapButton, 'text-lg color-text-02')}
                        onClick={onResetMapClick}
                        disabled={isResetMapDisabled}
                    >
                        reset the map
                    </button>{' '}
                    to see results.
                </p>
                <p className="text-md color-text-03">
                    You can start a new search in this area by clicking “Search Here” at
                    the top of the map.
                </p>
            </div>
        );
    }

    return (
        <div className={cx(styles.noResultsMessage, 'mt-3 mb-5')}>
            <div className="heading-sm mb-1">Sorry, no results found</div>
            <p className="text-lg color-text-02">
                Try removing dates and filters, searching a different location, or using
                the map to zoom out and search a larger area.
            </p>
        </div>
    );
}
